export default __webpack_public_path__ + "static/media/Bell_fill.2757d771.svg";